export default __webpack_public_path__ + "static/media/BackBtnImg.799f3c8f.svg";